export interface RadioButtonThemeProps {
    root: {
        base: string;
    };
    style: {
        auto: string;
        disabled: string;
    };
}
export const radioButtonTheme: RadioButtonThemeProps = {
    root: {
        base: 'w-[18px] h-[18px] flex items-center justify-center rounded-full border border-solid cursor-pointer m-[13px] focus:ring-0 ',
    },
    style: {
        auto: 'border-system-outline border-solid bg-system-surface-container hover:primary-hover-state-radius-inherit active:primary-active-state-radius-inherit focus:bg-system-primary focus:ring-system-primary text-system-primary',
        disabled: 'opacity-50 pointer-events-none',
    },
};
